// Only client components

import { useConnect } from '@wagmi/vue';

import { computed, useDevice } from '#imports';
import useProviderConfig from '~/composables/web3/EVM/useProviderConfig';
import type { EvmConnectorId } from '~/service/EVM/config/types';

export default function useWagmiConnectClient() {
    const { connect, 'connectors': wagmiConnectors, isPending, isSuccess, isError } = useConnect();

    const { connector: { config } } = useProviderConfig()(['connector']);

    const { isDesktop } = useDevice();

    const connectors = computed(() => {
        if (isDesktop) {
            const existMetamaskExtension = wagmiConnectors.find(connector => connector.id === config.metaMaskSDK.extensionId);
            if (existMetamaskExtension) {
                return [
                    {
                        ...existMetamaskExtension,
                        id: config.metaMaskSDK.id
                    },
                    ...wagmiConnectors.filter(connector => config[connector.id as EvmConnectorId] && connector.id !== config.metaMaskSDK.id)
                ];
            }
        }
        return wagmiConnectors.filter(connector => config[connector.id as EvmConnectorId]);
    });

    return {
        connectors,
        connect,
        isPending,
        isSuccess,
        isError
    };
}
